import React, { useState } from 'react';
import { SearchInput } from '../SharedComponents/InputComponents/SearchInput';
import { downloadFile } from '../../lib/iprs-react-library/src/SharedComponents/IprsHealthPortal/FileTreeComponents/utils/fileDownloadUtils';

const getStatusBadge = (report) => {
    const today = new Date().toISOString().split('T')[0];
    if (report.Deleted) return <span style={{ color: 'red', fontWeight: 'bold' }}>Deleted</span>;
    if (report.AccessValidTill < today) return <span style={{ color: 'orange', fontWeight: 'bold' }}>Expired</span>;
    return <span style={{ color: 'green', fontWeight: 'bold' }}>Active</span>;
};

const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB');
};

const OutputReportTable = ({ reports, api, onAction }) => {
    const [filteredReports, setFilteredReports] = useState(reports);
    const [editingExpiryId, setEditingExpiryId] = useState(null);
    const [newExpiry, setNewExpiry] = useState('');

    const searchProperties = ['PatientName', 'ClientName', 'CaseId', 'Name', 'Description'];

    // Keep filtered reports in sync when reports prop changes
    React.useEffect(() => {
        setFilteredReports(reports);
    }, [reports]);

    const handleExtendExpiry = (id) => {
        if (newExpiry) {
            onAction('extendExpiry', id, newExpiry);
            setEditingExpiryId(null);
            setNewExpiry('');
        }
    };

    if (!reports || reports.length === 0) {
        return <p>No reports found. Use the search filters above or insert a test record.</p>;
    }

    return (
        <div>
            <SearchInput
                data={reports}
                setFilteredData={setFilteredReports}
                filterProperties={searchProperties}
            />
            <table className="table" style={{ width: '100%', marginTop: '10px' }}>
                <thead>
                    <tr>
                        <th>Client Name</th>
                        <th>Patient Name</th>
                        <th>Case ID</th>
                        <th>Report Type</th>
                        <th>File Name</th>
                        <th>Date Published</th>
                        <th>Expires</th>
                        <th>Downloaded</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredReports.map((report) => (
                        <tr key={report.PkOutputReportTransferId}>
                            <td>{report.ClientName}</td>
                            <td>{report.PatientName}</td>
                            <td>{report.CaseId}</td>
                            <td>{report.ReportTypeName}</td>
                            <td>{report.Name}</td>
                            <td>{formatDate(report.DateInserted)}</td>
                            <td>
                                {editingExpiryId === report.PkOutputReportTransferId ? (
                                    <span>
                                        <input type="date" value={newExpiry}
                                            onChange={(e) => setNewExpiry(e.target.value)}
                                            style={{ width: '130px' }} />
                                        <button type="button" className="btn btn-sm btn-success"
                                            onClick={() => handleExtendExpiry(report.PkOutputReportTransferId)}>
                                            Save
                                        </button>
                                        <button type="button" className="btn btn-sm btn-default"
                                            onClick={() => setEditingExpiryId(null)}>
                                            Cancel
                                        </button>
                                    </span>
                                ) : (
                                    <span>
                                        {formatDate(report.AccessValidTill)}
                                        {' '}
                                        <button type="button" className="btn btn-sm btn-default"
                                            onClick={() => {
                                                setEditingExpiryId(report.PkOutputReportTransferId);
                                                setNewExpiry(report.AccessValidTill);
                                            }}
                                            title="Extend Expiry">
                                            &#9998;
                                        </button>
                                    </span>
                                )}
                            </td>
                            <td>{report.Downloaded ? '✓' : ''}</td>
                            <td>{getStatusBadge(report)}</td>
                            <td>
                                <button type="button" className="btn btn-sm btn-primary"
                                    onClick={() => downloadFile(report.FkReportGuid, api, report.Name)}
                                    title="Download">
                                    Download
                                </button>
                                {report.Downloaded && (
                                    <button type="button" className="btn btn-sm btn-default"
                                        onClick={() => onAction('markUnread', report.PkOutputReportTransferId)}
                                        title="Mark Unread">
                                        Mark Unread
                                    </button>
                                )}
                                {!report.Deleted ? (
                                    <button type="button" className="btn btn-sm btn-danger"
                                        onClick={() => {
                                            if (window.confirm('Delete this report transfer record?')) {
                                                onAction('delete', report.PkOutputReportTransferId);
                                            }
                                        }}
                                        title="Delete">
                                        Delete
                                    </button>
                                ) : (
                                    <button type="button" className="btn btn-sm btn-warning"
                                        onClick={() => onAction('restore', report.PkOutputReportTransferId)}
                                        title="Restore">
                                        Restore
                                    </button>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default OutputReportTable;
